import React, { Component } from "react"
import PhoneInput from "react-phone-number-input/react-responsive-ui"

import "react-phone-number-input/style.css"
import "react-responsive-ui/style.css"

class Phone extends Component {
  constructor(props) {
    super(props)
    this.state = {
      name: props.field.name,
      date: props.value || new Date(),
      phonePlaceholder: "Phone Number",
    }
  }

  handleChange = value => {
    console.log("HANDLE CHANGE", value)
    this.setState({ value })
    this.props.form.setFieldValue(this.state.name, value)
  }

  render() {
    const {
      field: { name, ...field },
      form: { touched, errors },
      options,
      label,
      ...rest
    } = this.props

    const error = errors[name]
    const touch = touched[name]

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-sm-12">
            <PhoneInput
              //   country="PK"
              inputClassName={
                error ? "form-control is-invalid" : "form-control"
              }
              error={error}
              // touch={touch}
              placeholder={this.state.phonePlaceholder}
              value={this.state.value}
              onChange={this.handleChange}
            />
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default Phone
